var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallAndDeploy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61524 3.72357L17.0412 3.70314C19.9864 3.69633 21.8233 5.7707 21.8301 8.71297L21.8486 16.6504C21.8564 19.5937 20.0292 21.6758 17.083 21.6827L8.65806 21.7031C5.71287 21.7099 3.8759 19.6355 3.86909 16.6933L3.8506 8.7548C3.84379 5.81254 5.67979 3.73038 8.61524 3.72357Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2798 10.8938V14.5045C17.2798 14.9705 17.0307 15.4015 16.6269 15.6351L13.5008 17.4399C13.097 17.6734 12.5988 17.6734 12.195 17.4399L9.06888 15.6351C8.6651 15.4015 8.41602 14.9705 8.41602 14.5045V10.8938C8.41602 10.4277 8.6651 9.99672 9.06888 9.76418L12.195 7.95834C12.5988 7.72483 13.097 7.72483 13.5008 7.95834L16.6269 9.76418C17.0307 9.99672 17.2798 10.4277 17.2798 10.8938Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59961 10.2275L12.8457 12.6843L17.0917 10.2275",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8477 17.6224V12.6807",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallAndDeploy);
export default __webpack_public_path__ + "static/media/install-and-deploy.eb454fd4.svg";
export { ForwardRef as ReactComponent };